import React, { useState, useEffect } from "react";
import { lang } from "../lang";

function DeadlineModule({ tasks }) {
  const [deadlineTasks, setDeadlineTasks] = useState([]);
  const [countdowns, setCountdowns] = useState({});

  useEffect(() => {
    // Filter tasks with deadlines (both isDeadline and hasDeadline)
    const findDeadlineTasks = (tasks, parentPath = []) => {
      let result = [];
      tasks.forEach((task, index) => {
        if ((task.isDeadline || task.hasDeadline) && task.deadline) {
          result.push({ ...task, path: [...parentPath, index] });
        }
        if (task.children && task.children.length > 0) {
          result = result.concat(
            findDeadlineTasks(task.children, [...parentPath, index, "children"])
          );
        }
      });
      return result;
    };

    const filteredTasks = findDeadlineTasks(tasks);
    setDeadlineTasks(filteredTasks);

    // Set up countdowns
    const updateCountdowns = () => {
      const newCountdowns = {};
      filteredTasks.forEach((task) => {
        const now = new Date();
        const deadlineDate = new Date(task.deadline);
        const diffMs = deadlineDate - now;
        const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        newCountdowns[task.id] = { days, hours, overdue: diffMs <= 0 };
      });
      setCountdowns(newCountdowns);
    };

    updateCountdowns();
    const interval = setInterval(updateCountdowns, 60000); // Update every minute
    return () => clearInterval(interval);
  }, [tasks]);

  if (deadlineTasks.length === 0) return null;

  return (
    <div className="deadline-module">
      <h3>{lang.deadlineModule.heading}</h3>
      <div className="deadline-tasks">
        {deadlineTasks.map((task) => (
          <div
            key={task.id}
            className={`deadline-task ${
              countdowns[task.id]?.overdue ? "overdue" : ""
            }`}
          >
            <div className="task-name">{task.name}</div>
            <div className="deadline-date">
              {new Date(task.deadline).toLocaleDateString()}
            </div>
            <div className="deadline-countdown">
              {countdowns[task.id]?.days} {lang.task.days},{" "}
              {countdowns[task.id]?.hours} {lang.task.hours}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default DeadlineModule;
